'use client';
import type { AdvertisingProps } from './data';

import { Container, ProductCard, SimpleGrid, Stack, Text } from '@/components';
import { useTranslation } from '@/hooks';
import { routes } from '@/statics';

const Advertising: AdvertisingProps = ({
  userSeenProducts,
  complementaryProducts,
}) => {
  const { t } = useTranslation('pages.products');

  return (
    <Container mb={{ base: '69px', md: '103px' }}>
      {complementaryProducts?.length > 0 && (
        <Stack mt={{ base: '50px', md: '72px' }}>
          <Stack
            align={{ base: 'center', md: 'flex-start' }}
            mb={{ base: '4', md: '8px' }}
            mr={{ base: 0, md: 8 }}
          >
            <Text fontSize="3xl" fontWeight={800}>
              {t('complementaryProducts')}
            </Text>
            <Text fontSize="md" fontWeight={700}>
              {t('selectProduct')}
            </Text>
          </Stack>
          <SimpleGrid gap="4" columns={{ base: 1, md: 2, lg: 3, xl: 4 }}>
            {complementaryProducts
              ?.slice(0, 4)
              .map((product) => (
                <ProductCard
                  key={product.id}
                  cardData={product}
                  link={routes.product.href(product.code)}
                />
              ))}
          </SimpleGrid>
        </Stack>
      )}
      {userSeenProducts.length > 0 && (
        <Stack mt={{ base: '50px', md: '72px' }}>
          <Stack
            align={{ base: 'center', md: 'flex-start' }}
            mb={{ base: '4', md: '8px' }}
            mr={{ base: 0, md: 8 }}
          >
            <Text fontSize="3xl" fontWeight={800}>
              {t('yourLastVisit')}
            </Text>
            <Text fontSize="md" fontWeight={700}>
              {t('selectProduct')}
            </Text>
          </Stack>
          <SimpleGrid gap="4" columns={{ base: 1, md: 2, lg: 3, xl: 4 }}>
            {userSeenProducts
              ?.slice(0, 4)
              .map((product) => (
                <ProductCard
                  key={product.id}
                  cardData={product}
                  link={routes.product.href(product.code)}
                />
              ))}
          </SimpleGrid>
        </Stack>
      )}
    </Container>
  );
};
export default Advertising;
